// Client for Keyword-to-Sales Attribution.
//
// Its own endpoints, not the Keyword Performance ones: the two surfaces answer
// to different documents and must be able to change independently.
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const BASE = `${API_URL}/seller-intelligence/search-attribution`;

const headers = (token) => ({
  Authorization: `Bearer ${token}`,
  'Content-Type': 'application/json',
});

export class NotConnectedError extends Error {
  constructor(message) {
    super(message || 'Amazon account not connected');
    this.notConnected = true;
  }
}

const call = async (url, options) => {
  const res = await fetch(url, options);
  const data = await res.json().catch(() => ({}));
  if (res.status === 409 && data.connected === false) throw new NotConnectedError(data.error);
  if (!res.ok || !data.success) throw new Error(data.error || `Request failed (${res.status})`);
  return data;
};

const query = (params) => {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') search.set(k, v);
  });
  return search.toString();
};

// SF1-SF5 as five cards. SF2 and SF3 come back absent, never zero.
export const getOverview = (token, params) =>
  call(`${BASE}/overview?${query(params)}`, { headers: headers(token) });

// SF1 and SF4 per product.
export const getProducts = (token, params) =>
  call(`${BASE}/products?${query(params)}`, { headers: headers(token) });

// The roll-up: products by search share and by dependency.
export const getAccount = (token, params) =>
  call(`${BASE}/account?${query(params)}`, { headers: headers(token) });

// SF5 — the segment, the per-product split, then the candidates.
export const getLongTail = (token, params) =>
  call(`${BASE}/long-tail?${query(params)}`, { headers: headers(token) });

// One term's revenue across the products that earn it. Arrived at from Keyword
// Performance, where a seller reading a term asks what it is worth.
export const getTerm = (token, term, params) =>
  call(`${BASE}/term/${encodeURIComponent(term)}?${query(params)}`,
       { headers: headers(token) });

// What changed about the seller's products since the window before — the half
// of the alert pass this feature owns.
export const getChanges = (token, params) =>
  call(`${BASE}/changes?${query(params)}`, { headers: headers(token) });
